import Link from "next/link";

/**
 * The auth card's heading and footer, as plain components so two owners can
 * render them identically: `AuthLayout` (server) for the pages whose chrome is
 * static, and the register card (client), which swaps heading + footer per
 * state — "Create your account" while the form is up, "Check your inbox" once
 * it is sent. One place for the styling, no drift between the two.
 */
export function AuthHeading({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <>
      <h1 className="!text-foreground !text-[1.75rem] !font-extrabold !tracking-tight sm:!text-[2rem]">
        {title}
      </h1>
      {subtitle ? <p className="mt-2.5 text-mid-gray leading-relaxed">{subtitle}</p> : null}
    </>
  );
}

export function AuthFooter({ children }: { children: React.ReactNode }) {
  return <div className="mt-8 border-t border-black/[0.06] pt-6 text-sm">{children}</div>;
}

/** The footer's one emphasised link ("Sign in", "Create your account"). */
export function AuthFooterLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <Link
      href={href}
      className="font-bold text-teal underline decoration-accent decoration-2 underline-offset-4 hover:text-gold"
    >
      {children}
    </Link>
  );
}
